import React from "react";
import { useHistory } from "react-router-dom";
import "./content-component.scss";

export default function ContentComponent(props) {
	const history = useHistory();
	return (
		<section className="content-section">
			<div className="container">
				{/* <div className="row" style={{marginBottom: "5rem"}}>
					<div className="col-12 col-md-6">
						<img
						src="/assets/images/TEM-Raya2026-Event-Desktop.jpg"
						alt="Service your vehicle and receive a special complimentary gift!"
						width="100%"
						className="d-none d-md-block mb-3"
						style={{borderRadius: "2rem"}}
						/>
						<img
						src="/assets/images/TEM-Raya2026-Event-Mobile.jpg"
						alt="Service your vehicle and receive a special complimentary gift!"
						width="100%"
						className="d-md-none mb-3"
						style={{borderRadius: "1.5rem"}}
						/>
					</div>
					<div className="col-12 col-md-6">
						<div>
						<h2 style={{fontSize: "1.625rem", textTransform: "none"}}>
							<b>
								Syiok Drive, Syiok Reward This Raya
							</b>
						</h2>
						<p>
							From <b>9 March – 10 May 2026</b>, purchase any selected <b>TotalEnergies Quartz Syiok!</b> products and service your vehicle at participating TotalEnergies Authorized Workshops to receive a FREE festive gift.
						</p>
						<p>
							<b>FREE Airtight Storage Container (While stocks last)</b>
						</p>
						<p>
							Perfect for storing festive treats, snacks, or essentials during your balik kampung journey.
						</p>
						<p>
							Find a&nbsp;
							<a
							href="https://totalenergies.my/automotive-products/store-locator"
							target="_blank"
							className="text-primary"
							>
							workshop
							</a>&nbsp;near you and make a service reservation now.
						</p>
						<p>
							<a
							href="https://totalenergies.my/totalenergies-2026-syiok-drive-syiok-reward-campaign-terms-conditions"
							target="_blank"
							className="text-primary"
							>
							Terms &amp; Conditions
							</a> apply. While stocks last.
						</p>
						<p>&nbsp;</p>
						</div>
					</div>
				</div> */}
				<div className="row mb-4">
					<div className="col-12 col-md-6">
						<img src="/assets/images/promotion-bg-desktop.png" alt="Refer & earn with Syiok! Loyalty Programme" width="100%" className="d-none d-md-block mb-3" style={{ borderRadius: "2rem" }} />
						<img src="/assets/images/promotion-bg.png" alt="Refer & earn with Syiok! Loyalty Programme" width="100%" className="d-md-none mb-3" style={{ borderRadius: "1.5rem" }} />
					</div>
					<div className="col-12 col-md-6">
						<div>
							<h2 style={{ fontSize: "1.625rem" }}>
								<b>On top of your free engine oil, you can also get other freebies from us!</b>
							</h2>
							<p>All you have to do is get your friends to service their vehicle with Quartz engine oil at our Quartz Auto Services (QAS).</p>
							<p>Upon the successful completion of their first service, you will be rewarded with limited edition merchandise!</p>
							<p>How to earn, you ask? Click the button below!</p>
							<p>
								<a href={process.env.PUBLIC_URL + "/assets/pdf/Quartz Syiok!_Loyalty Programme_MGM_T&C_25052023.pdf"} target="_blank" className="text-primary">
									Terms &amp; conditions apply.
								</a>
							</p>
							<button className="tom-button primary-button px-5" style={{ width: "fit-content", minWidth: "15rem" }} onClick={() => history.push("/refer-and-earn")}>
								Refer A Friend
							</button>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
